var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v(" Other restaurants ")]),_c('OtherRestaurants')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }